import React from 'react'
import PageLayout from '../pagelayout';
import Team from "./team";
import {Helmet} from "react-helmet";

const TeamPage = () => {
    return (
        <PageLayout fullWidth pad={false} headerbg={'#feec6b'}>
            <div className="container">
                <div className="flex-center">
                    <h1 className="m-t-30 m-b-45 f-54 f-600 header-underline">Our Team</h1>
                </div>
                <Team />
            </div>
        </PageLayout>        
    )
}

export default TeamPage
